module.exports = __webpack_public_path__ + "img/Dantam Hair 21.aea6f7a4.jpg";